export default __webpack_public_path__ + "static/media/icon_clear_x_hover.90cfe11d.svg";